var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1627 17.9792V17.9785H18.1672V11.3772C18.1672 8.14781 17.4685 5.66016 13.6744 5.66016C11.8505 5.66016 10.6264 6.65612 10.1267 7.60033H10.074V5.96165H6.47656V17.9785H10.2225V12.0282C10.2225 10.4615 10.5209 8.94654 12.4708 8.94654C14.3919 8.94654 14.4206 10.7345 14.4206 12.1287V17.9792H18.1627Z",
    fill: "#000B33"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.376953 5.9834H4.12738V18.0002H0.376953V5.9834Z",
    fill: "#000B33"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.26201 0C1.06287 0 0.0898438 0.968214 0.0898438 2.16142C0.0898438 3.35463 1.06287 4.34309 2.26201 4.34309C3.46115 4.34309 4.43418 3.35463 4.43418 2.16142C4.43343 0.968214 3.4604 0 2.26201 0V0Z",
    fill: "#000B33"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.8044463047b8194c81e75d5a8ed3a2b3.svg";
export { ForwardRef as ReactComponent };